import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
} from "@mui/material";
import { Btn } from "@client/ui";

interface ServiceProps {
  header: string;
  body: string;
  image: string;
  navigateTo: string;
}

const Service: React.FC<ServiceProps> = ({
  header,
  body,
  image,
  navigateTo,
}) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ position: "relative", width: "100%", height: "600px" }}>
      <CardMedia
        component="img"
        image={image}
        alt="service image"
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      <CardContent
        className=" bg-background-light/70  p-4"
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          //backdropFilter: "blur(60%)",
          // backdropFilter: "blur(8px)", // Creates a blur effect for content behind

          color: "#fff",
        }}
      >
        <div className="font-primary font-bold text-[40px]">{header}</div>
        <div>{body}</div>
      </CardContent>
      <CardActions sx={{ position: "absolute", bottom: 0, right: 0, m: 2 }}>
        <Btn text={" Go to Service"} onClick={() => navigate(navigateTo)} />
      </CardActions>
    </Card>
  );
};

export default Service;
